import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getRequest, postRequest } from 'utils/requests';
import {
  ClearButton,
  DatePicker,
  EmptyState,
  Loading,
  PageTitle,
  RadioButton,
  SelectDropDown
} from 'components/common/Elements/Elements';
import CohortTable from './CohortTable/CohortTable';
import { createFilterSize } from 'utils/common';
import { createCohortData, createReqBody } from './helpers/helpers';

import classes from './CohortArr.module.scss';

const CohortArr = () => {
  const { t } = useTranslation(['activity']);
  const history = useHistory();

  const initialState = {
    // data from API
    cohortData: {},
    cohortFilters: [],

    // filters
    date: { startDate: null, endDate: null },
    unit: t('activity:units.PERCENT'),
    channel: [],
    size: [],
    plan: [],
    dataConection: false,
    filterConection: false,
    trigerResetDatePicker: false,

    // other data
    loader: true,
    loaderTable: false
  };

  const [state, setState] = useState(initialState);

  let cohortSize = [];

  const average = t('activity:cohorts.AVERAGE');
  const units = [t('activity:units.PERCENT'), t('activity:units.DOLLARS')];
  const numberОfFilters = 5;

  const handleDateChange = value => {
    setState(prevState => ({
      ...prevState,
      date: value
    }));
  };

  const handleUnit = e => {
    if (e.target.value !== state.unit) {
      setState(prevState => ({
        ...prevState,
        unit: e.target.value
      }));
    }
  };

  const handleChannel = e => {
    setState(prevState => ({
      ...prevState,
      channel: e
    }));
  };

  const handleSize = e => {
    setState(prevState => ({
      ...prevState,
      size: e
    }));
  };

  const handlePlan = e => {
    setState(prevState => ({
      ...prevState,
      plan: e
    }));
  };

  const resetAllfilters = () => {
    setState(prevState => ({
      ...prevState,
      unit: t('activity:units.PERCENT'),
      date: { startDate: null, endDate: null },
      channel: [],
      size: [],
      plan: [],
      trigerResetDatePicker: !prevState.trigerResetDatePicker
    }));
  };

  useEffect(() => {
    let cancelled = false;
    getRequest('/cohorts/filters')
      .then(res => {
        if (!cancelled) {
          if (res.body) {
            setState(prevState => ({
              ...prevState,
              cohortFilters: res.body,
              filterConection: true
            }));
          } else {
            setState(prevState => ({
              ...prevState,
              filterConection: false
            }));
          }
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setState(prevState => ({
            ...prevState,
            filterConection: false
          }));
        }
      });
    return () => (cancelled = true);
  }, []);

  useEffect(() => {
    let cancelled = false;
    setState(prevState => ({
      ...prevState,
      loaderTable: true
    }));

    const linkForRequest = '/cohorts/arr';
    const REQ_BODY = createReqBody(state.channel, state.size, state.plan);

    postRequest(linkForRequest, REQ_BODY)
      .then(res => {
        if (!cancelled) {
          if (Object.keys(res.body).length) {
            setState(prevState => ({
              ...prevState,
              cohortData: res.body.data,
              dataConection: true,
              loader: false,
              loaderTable: false
            }));
          } else {
            setState(prevState => ({
              ...prevState,
              dataConection: false,
              loader: false,
              loaderTable: false
            }));
          }
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setState(prevState => ({
            ...prevState,
            loader: false,
            loaderTable: false,
            dataConection: false
          }));
        }
      });
    return () => (cancelled = true);
  }, [state.channel, state.size, state.plan, history.location.search]);

  (function () {
    createFilterSize(state.cohortFilters.companySize, cohortSize);
  })();

  const cohortTable = createCohortData(state.cohortData, state.date, average);

  if (state.loader) {
    return <Loading />;
  }

  if (!state.dataConection || !state.filterConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <>
      <PageTitle title={t('activity:cohorts.COHORT_ARR')} />
      <div className={classes.filters_wrap}>
        <div className={classes.filters}>
          <DatePicker
            label={t('activity:filters.DATE')}
            input={{
              value: state.date,
              onChange: handleDateChange
            }}
            position="bottom left"
            trigerResetDatePicker={state.trigerResetDatePicker}
          />
          <SelectDropDown
            options={state.cohortFilters.channel}
            input={{ value: state.channel, onChange: handleChannel }}
            label={t('activity:filters.CHANNEL')}
            multi
          />
          <SelectDropDown
            options={state.cohortFilters.plan}
            input={{ value: state.plan, onChange: handlePlan }}
            label={t('activity:filters.PRICING_PLAN')}
            multi
          />
          <SelectDropDown
            options={cohortSize}
            input={{ value: state.size, onChange: handleSize }}
            label={t('activity:filters.COMPANY_SIZE')}
            multi
            renderKey={'label'}
          />
          <div className={classes.input}>
            <RadioButton
              handleUnit={handleUnit}
              unit={state.unit}
              units={units}
              name={t('activity:units.UNIT')}
              title={t('activity:units.UNIT')}
              classTitle={classes.radio}
            />
          </div>
          <ClearButton
            onClick={() => resetAllfilters(true)}
            numberОfFilters={numberОfFilters}
          />
        </div>
      </div>
      <CohortTable
        tableData={cohortTable}
        loader={state.loaderTable}
        unit={state.unit}
      />
    </>
  );
};

export default CohortArr;
